/*!
 * Helper functions for script editor control
 * Copyright 2022, Selerix Systems, Inc. All Rights Reserved
 * This is unpublished proprietary source code of Selerix, Inc. The
 * copyright notice above does not evidence any actual or intended
 * publication of such source code.
 */

/**
 * @typedef {Object} JScriptEditorSettings
 * @property {string=} id
 * @property {string=} containerID
 * @property {string=} tokenID
 * @property {string=} token
 * @property {string=} editorID
 * @property {boolean=} locked
 * @property {string=} serviceUrl
 * @property {string=} controlsUrl
 */

/**
 * 
 * @param {JScriptEditorSettings=} settings 
 */
var JScriptEditor = function (settings) {
	settings = settings || {};

	var self = this;
	this.id = settings.id || 'JSScriptEditorContainer';
	this.containerID = settings.containerID || 'jsContainer';
	this.tokenID = settings.tokenID || '_tokenID';
	this.token = settings.token || null;
	this.editorID = settings.editorID || 'jsEditor';
	this.locked = settings.locked !== void 0 ? settings.locked : true;
	this.serviceUrl = settings.serviceUrl || null;
	this.controlsUrl = settings.controlsUrl || null;
	this.editorObj = null;
	this.initialized = $('#' + this.id).length > 0 && $('#' + this.id).data('initialized');

	this.isInitialized = function () {
		return self.initialized === true || $('#' + self.id).attr('data-initialized') === 'true';
	};

	this.val = function (value) {
		if (self.editorObj === void 0 || self.editorObj === null) {
			throw 'Cannot find Monaco Editor Object.';
		}

		if (value === void 0) return self.editorObj.editor.getModel().getValue();
		else {
			self.editorObj.editor.getModel().setValue(value);
			if (value === '') $('#' + self.id).find('.view-lines').empty();
		}
	};

	this.getObject = function () {
		if (self.editorObj === null || self.editorObj === void 0) {
			var editor = $('#' + self.editorID);
			if (editor.length) self.editorObj = $.data(editor[0], 'editorObj');
		}
		return self.editorObj;
	};

	this.setLock = function () {
		// TODO: This function is intended to be able to un/lock the editor but the editor's readonly state is only set during creation.
		// Until this is corrected, dispose the existing editor, set the locked property, and then call _init again.

		//var t = $('#' + self.id).find('textarea').first(), v = $('#' + self.id).find('.view-overlays').first();
		//if (self.locked) {
		//    t.attr('disabled', 'disabled');
		//    v.hide();
		//} else {
		//    t.removeAttr('disabled').height('auto');
		//    v.show();
		//}

		return;
	};

	this._init = function (initDoneCb) {
		if (Page_BusyBox.Initializing === true || self.editorObj) {
			console.debug("JScriptEditor double _init() - skipped.");
			return;
		}

		if (self.isInitialized() && self.editorObj) {
			$('#' + self.tokenID).val(self.token);
			if (initDoneCb) initDoneCb();
			return;
		}

		// store token
		$('#' + self.tokenID).val(self.token);

		// fix tooltips
		$('#' + self.containerID).find('[data-toggle="tooltip"]').tooltip();

		// initialize the editor
		initJSScriptEditor(self.editorID, self.tokenID, self.locked, 'text/typescript', true, self.serviceUrl, function () {
			self.initialized = true;
			$('#' + self.containerID).find('#' + self.id).attr('data-initialized', self.initialized);
			self.getObject();
			self.setLock();
			if (initDoneCb) initDoneCb();
		});
	};

	this.dispose = function (callback) {
		if (!self.initialized) return;
		disposeJSScriptEditor(self.editorObj, callback);
		self.initialized = false;
		self.editorObj = null;

		$('#' + self.containerID).empty();
	};

	/**
	 * Initialize JavaScript editor.
	 * 
	 * @param {string} id Identifier for HTML editor.
	 * @param {string} resultId Identifier for result field.
	 * @param {boolean} readOnly Is editor in readonly mode.
	 * @param {string} editMode Edit mode format.
	 * @param {boolean} useWebApi Is using web-api.
	 * @param {string} webApiUrl Web-api url.
	 * @param {Function} callback Callback after initialization is complete.
	 */
	this.initEditor = function (id, resultId, readOnly, editMode, useWebApi, webApiUrl, callback) {
		initJSScriptEditor.call(self, id, resultId, readOnly, editMode, useWebApi, webApiUrl, callback);
	};

	this.toggleEditorActionFind = function (el, selector, containerSelector) {
		toggleJSScriptEditorActionFind(el, selector, containerSelector);
	};

	this.toggleEditorActionReplace = function (el, selector, containerSelector) {
		toggleJSScriptEditorActionReplace(el, selector, containerSelector);
	};

	this.formatContent = function (el, cmd, selector, containerSelector) {
		execJSScriptEditorAction(el, cmd, selector, containerSelector);
	};
};

function _getJSScriptEditor($holder, selector) {
	var $editor = $holder.find(selector);
	if ($editor && $editor.length > 0) {
		return $.data($editor[0], 'editorObj');
	}
}

function _getJSScriptEditorById(id) {
	var $editor = $('#' + id);
	if ($editor && $editor.length > 0) {
		return $.data($editor[0], 'editorObj');
	}
}


function resizeJSScriptEditorImpl(editorObj) {
	if (editorObj) {
		// resize editor to fill the parent container
		editorObj.editor.layout();
	}
}

function resizeJSScriptEditor(editorObj, $holder, isDialog) {
	if (editorObj) {
		// if $holder is present editor would be inscribed into it - aka fullscreen
		if ($holder && $holder.length > 0 && editorObj.domNode) {
			// min editor height in fullscreen dialog mode - 360px
			var defaultEditorHeight = 360;

			// adjust editor holder height but keep responsive
			var $editorHolder = $(editorObj.domNode).parent();

			// set default height to calculate the holder's height right enough
			$editorHolder.outerHeight(defaultEditorHeight);

			var oHeight = $holder.outerHeight();

			if (isDialog) {
				// dialog content height except dialog header
				oHeight -= $holder.find('.modal-header').outerHeight();

				// and dialog footer
				oHeight -= $holder.find('.modal-footer').outerHeight();

				var $dialogBody = $holder.find('.modal-body');
				$dialogBody.outerHeight(oHeight);

				// and some place for dialog body padding and margin
				oHeight -= $dialogBody.outerHeight() - $dialogBody.height();

				// and additional controls like "Save to all rate groups"
				oHeight -= 30;

				// check min editor height
				if (oHeight < defaultEditorHeight) oHeight = defaultEditorHeight;
			}

			// $holder height except controls
			oHeight -= $holder.find('.editor-controls').outerHeight();

			$editorHolder.outerHeight(oHeight);
		}

		resizeJSScriptEditorImpl(editorObj);
	}
}

function toggleJSScriptEditorActionFind(el, selector, containerSelector) {
	var $holder = containerSelector ? $(el).closest(containerSelector) : $(el).parent();
	var editorObj = _getJSScriptEditor($holder, selector);
	if (editorObj.isFindAndReplaceWidgetShown) {
		// close far widget
		execJSScriptEditorActionImpl(editorObj, "closeFindWidget");
		editorObj.isFindAndReplaceWidgetShown = false;
	}
	if (editorObj.isFindWidgetShown) {
		// close f widget
		execJSScriptEditorActionImpl(editorObj, "closeFindWidget");
		editorObj.isFindWidgetShown = false;
	} else {
		execJSScriptEditorActionImpl(editorObj, "actions.find");
		editorObj.isFindWidgetShown = true;
		editorObj.isFindAndReplaceWidgetShown = false;
	}
}

function toggleJSScriptEditorActionReplace(el, selector, containerSelector) {
	var $holder = containerSelector ? $(el).closest(containerSelector) : $(el).parent();
	var editorObj = _getJSScriptEditor($holder, selector);
	if (editorObj.isFindAndReplaceWidgetShown) {
		// close far widget
		execJSScriptEditorActionImpl(editorObj, "closeFindWidget");
		editorObj.isFindAndReplaceWidgetShown = false;
	} else {
		execJSScriptEditorActionImpl(editorObj, "editor.action.startFindReplaceAction");
		editorObj.isFindAndReplaceWidgetShown = true;
		editorObj.isFindWidgetShown = false;
	}
}

function execJSScriptEditorAction(el, cmd, selector, containerSelector) {
	var $holder = containerSelector ? $(el).closest(containerSelector) : $(el).parent();
	execJSScriptEditorActionImpl(_getJSScriptEditor($holder, selector), cmd);
}

function execJSScriptEditorActionImpl(editorObj, cmd) {
	editorObj.editor.focus();
	editorObj.editor._keybindingService.executeCommand(cmd);
}

// -- fullscreen refion

function toggleAbsPFullscreen($holder, resizeCallback, holderClass, bodyClass) {
	var holderClass = holderClass || 'absp-fullscreen';
	var bodyClass = bodyClass || 'body-absp-fullscreen';

	var mLeft = 0, mTop = 0;
	this.onResize = function (ev) {
		if ($holder.hasClass(holderClass)) {
			var rect = $holder[0].getBoundingClientRect();
			if (rect.left != 0) mLeft -= rect.left;
			if (rect.top != 0) mTop -= rect.top;
			$holder.css('margin-left', mLeft);
			$holder.css('margin-top', mTop);
		} else {
			$(window).off('resize.' + holderClass);
		}

		if (resizeCallback) {
			resizeCallback(ev);
		}
	};

	var isFullscreen = $holder.hasClass(holderClass);

	if (isFullscreen) {
		$holder.css('margin-left', 0);
		$holder.css('margin-top', 0);
	} else {
		$(window).on('resize.' + holderClass, this.onResize);
	}

	$(document.body).toggleClass(bodyClass);
	$holder.toggleClass(holderClass);

	// fix document scrolling on cancel dialog
	var $modal = $holder.closest('.modal');
	if ($modal && $modal.length > 0) {
		$holder.find(":submit:contains('Cancel')").click(function (e) {
			e.preventDefault();
			e.stopPropagation();
			$modal.find('.close').click();
		});
	}

	this.onResize();

	return this;
}

function toggleJSScriptEditorFullscreen(el, editorSelector, containerSelector) {
	var $holder = containerSelector ? $(el).closest(containerSelector) : $(el).parent();
	var holderFSClass = 'monaco-editor-fullscreen';
	var bodyFSClass = 'monaco-editor-in-fullscreen';

	// when the editor placed inside Bootstrap's modal dialog
	// we should toggle fullscreen mode for the entire dialog
	var $dialogBody = $holder.closest('.modal-dialog[role="document"] .modal-content');
	var isDialog = $dialogBody.length > 0;
	if (isDialog) {
		var $modal = $dialogBody.closest('.modal');
		$modal.on('hide.bs.modal', function (e) {
			if ($dialogBody.hasClass(holderFSClass)) {
				// exit fullscreen mode on dialog close
				toggleAbsPFullscreen($dialogBody, null, holderFSClass, bodyFSClass);
			}
		});

		$holder = $dialogBody;

		// restory dialog body state
		$holder.find('.modal-body').removeAttr('style');
	}

	// generic fullscreen mode
	toggleAbsPFullscreen($holder, function (ev) {
		var editorObj = _getJSScriptEditor($holder, editorSelector);

		if ($holder.hasClass(holderFSClass)) {
			// inscribe into holder
			resizeJSScriptEditor(editorObj, $holder, isDialog);
		} else {
			// default resize
			if (editorObj.onWindowResize) {
				editorObj.onWindowResize();
			}
		}
	}, holderFSClass, bodyFSClass);
}

// -- end of fullscreen region

function initJSScriptEditorSnippetButton(id) {
	var $btn = $('#codeSnippetsDropdown');
	if ($btn && $btn.length > 0) {
		var $snList = $btn.parent().find('ul');
		$snList.empty();

		var tabIndex = $btn.attr('tabindex');

		var snippets = window.TSSnippetService.codeSnippets;
		for (var i = 0; i < snippets.length; i++) {
			var snippet = snippets[i];
			if (snippet.displayName) {
				$snList.append('<li><a href="javascript:void(0);" tabindex="' + ++tabIndex
					+ '" onclick="javascript:execJSScriptEditorInsertSnippet(\''
					+ id + '\', '
					+ i + ')">' + snippet.displayName + '</a></li>');
			}
		}
	}
}

function execJSScriptEditorInsertSnippet(id, index) {
	var editorObj = _getJSScriptEditorById(id);
	execJSScriptEditorInsertSnippetImpl(editorObj.editor, window.TSSnippetService.codeSnippets[index]);
}

function execJSScriptEditorInsertSnippetImpl(editor, snippet) {
	var ctrl = editor.contributions["editor.contrib.suggestController"];
	var model = ctrl.model;
	model.context = {};
	model.raw = [];

	editor.focus();

	this.shiftToSelectionStart = function (line, selection) {
		// shift to the left to start position
		for (var p = 0; p < selection.startColumn - 1; p++) {
			if (line[0] === ' ') {
				line = line.substring(1);
			} else {
				break;
			}
		}
		return line;
	};

	var codeSnippet = snippet.codeSnippet;

	// process selected text if present
	var selection = editor.getSelection();
	if (selection && !(selection.startColumn === selection.endColumn
		&& selection.startLineNumber === selection.endLineNumber)) {
		var selectedText = editor.model.getValueInRange(selection);
		if (selectedText) {
			// fix braces issue before formating
			selectedText = selectedText.replace(/ *\r\n *\{ *\r\n/gm, ' {\r\n');
			selectedText = selectedText.replace(/ *\n *\{ *\n/gm, ' {\n');

			var insertPattern = '{{}}';
			if (codeSnippet.lastIndexOf(insertPattern) !== -1) {
				// format code
				var matches = codeSnippet.match(/( *)\{\{\}\}/);
				if (matches && matches.length === 2) {
					var indent = matches[1];
					if (indent) {
						var stLines = selectedText.split('\n');
						selectedText = '';
						for (var i = 0; i < stLines.length; i++) {
							var lineText = shiftToSelectionStart(stLines[i], selection);

							// add snippet indent
							selectedText += indent + lineText;

							if (i < stLines.length - 1) {
								selectedText += '\n';
							}
						}

						insertPattern = indent + insertPattern;
					}
				}

				// preserve place for snippet editing cursor
				selectedText += '\r\n' + insertPattern;

				// insert selected text into snippet
				codeSnippet = codeSnippet.replace(/( *)\{\{\}\}/, selectedText);
			} else {
				var stLines = selectedText.split('\n');
				selectedText = stLines[0];
				if (stLines.length > 1) {
					selectedText += '\n';
				}

				for (var i = 1; i < stLines.length; i++) {
					selectedText += shiftToSelectionStart(stLines[i], selection);

					if (i < stLines.length - 1) {
						selectedText += '\n';
					}
				}

				// insert snippet after selected text
				codeSnippet = selectedText + '\r\n' + codeSnippet;
			}
		}
	}

	model.accept({ codeSnippet: codeSnippet }, 0, 0);
}

function showJSScriptEditorLoadingIndicator() {
	if (Page_BusyBox.Initializing) {
		throw 'Another editor initialization is in progress - something wrong with UI flow.';
	}

	ShowBusyBox();
	if (Page_BusyBox.Timeout !== null) clearTimeout(Page_BusyBox.Timeout);

	var el = $('#' + Page_BusyBox.ID);
	el.addClass('transparent');
	el.children('span').attr('aria-busy', true).show();

	Page_BusyBox.Hide = function () { };
	Page_BusyBox.Initializing = true;
}

function hideJSScriptEditorLoadingIndicator(timeout) {
	Page_BusyBox.Initializing = false;
	Page_BusyBox.Hide = ProcessingBox.prototype.Hide;
	Page_BusyBox.Hide(timeout);
}

var KeepAliveKeypressTimer = function (interval) {
	// This class is used to keep call selerix.session.keepAlive() if a key is pressed.
	this.lastChangeTime = null;
	this.keepAliveInterval = interval;
	this.timer = null;
};

KeepAliveKeypressTimer.prototype.keepAliveTimer = function () {
	// send "keep alive" every minute during which we editing something
	if (this.lastChangeTime === null) {
		return;
	}
	var now = (new Date()).getTime();
	var lastChangedTime = this.lastChangeTime.getTime();

	if (now - lastChangedTime <= this.keepAliveInterval) {
		this.lastChangeTime = null;
		selerix.session.keepAlive();
	}
};

KeepAliveKeypressTimer.prototype.start = function () {
	var that = this;
	if (selerix !== undefined && selerix.session !== undefined && typeof (selerix.session.keepAlive) === 'function') {
		that.timer = setInterval(function () {
			that.keepAliveTimer(); // https://novogeek-archive.azurewebsites.net/post/Scope-problems-with-JavaScript-setInterval-setTimeout-Use-closures!
		}, that.keepAliveInterval);
	}
	return that;
};

KeepAliveKeypressTimer.prototype.stop = function () {
	if (this.timer) {
		clearInterval(this.timer);
		this.timer = null;
	}
	return this;
};

/**
 * Please do not forget call disposeJSScriptEditor() method if the editor no longer needed.
 * Also please keep in mind that multiple editor instances on a same window are allowed by design.
 * 
 * @param {string} id
 * @param {string} resultId
 * @param {boolean} readOnly
 * @param {boolean} editMode
 * @param {boolean} useWebApi
 * @param {any} webApiUrl
 * @param {any} callback
 * @returns
 */
function initJSScriptEditor(id, resultId, readOnly, editMode, useWebApi, webApiUrl, callback) {
	'use strict';

	var self = this;
	if ($('#' + id).attr('data-initializing')) {
		return;
	} else {
		$('#' + id).attr('data-initializing', true);
	}

	// Monaco Editor markup generator currently does not work inside containers
	// with "fixed" "position" and/or with zero "width" or "height"
	// so we should fix bootstrap's Modal default style
	var $modalHost = $('div.modal:has(#' + id + ')');
	var holderResize = function () { };
	if ($modalHost && $modalHost.length > 0 && $modalHost.data('absolute') !== false) {
		holderResize = toggleAbsPFullscreen($modalHost).onResize;
	}

	var originalCallback = callback;
	callback = function () {
		if (typeof (originalCallback) === 'function') originalCallback();
		// layout async
		setTimeout(function () { if (holderResize) holderResize(); }, 0);
	};

	showJSScriptEditorLoadingIndicator();

	if (readOnly) {
		$('[data-in-edit-mode-only="true"]').attr('disabled', 'disabled');
	} else {
		if ($('[data-in-edit-mode-only="true"]').attr('disabled') == 'disabled') {
			$('[data-in-edit-mode-only="true"]').attr('disabled', false);
		}
		initJSScriptEditorSnippetButton(id);
	}

	var $editor = $('#' + id);

	// save se editor object data for future use
	$.data($editor[0], 'timer', new KeepAliveKeypressTimer(60 * 1000 /* 1 minute */).start());

	var $result = $('#' + resultId);

	if (!useWebApi) {
		initJSScriptEditorImpl.call(self, $editor, null, null, readOnly, editMode, function (editorObj) {
			editorObj.editor.on('change', function (e) {
				var keepAliveTimer = $.data($editor[0], "timer");
				if (keepAliveTimer) {
					keepAliveTimer.lastChangeTime = new Date();
				}
			});

			// store current value in the hidden field
			$result.val(editorObj.editor.getModel().getValue());

			hideJSScriptEditorLoadingIndicator(1000);
			if (typeof (callback) === 'function') callback();
		});
	} else {
		// store Web Api URL
		$.data($editor[0], 'WebApiUrl', webApiUrl);

		var token = $result.val();
		if (!$.data($editor[0], 'editorObj')) {
			$.ajax({
				type: 'GET',
				url: webApiUrl + '?token=' + token,
				dataType: 'json',
				crossDomain: true,
				//xhrFields: {
				//    withCredentials: true
				//},
			}).done(function (data) {
				if (data && typeof (data.script) !== 'undefined') {
					if (data.script === null) data.script = '';
					$editor.text(data.script);

					var code = null;
					if (/*typeof (data.overrides) !== 'undefined' && data.overrides !== null
						&& */typeof (data.variables) !== 'undefined' && data.variables !== null) {
						code = GenerateTSCodeForVariablesAndOverrides(data.overrides, data.variables);
					}

					loadJSScriptEditorIncludes(data.scriptIncludes, token, function (externalLibsData) {
						initJSScriptEditorImpl.call(self, $editor, code, externalLibsData, readOnly, editMode, function (editorObj) {
							editorObj.editor.on('change', function (e) {
								var keepAliveTimer = $.data($editor[0], "timer");
								if (keepAliveTimer) {
									keepAliveTimer.lastChangeTime = new Date();
								}
							});

							hideJSScriptEditorLoadingIndicator(1000);
							if (typeof (callback) === 'function') callback();
						});

						// store data object without script
						data.script = '';
						$.data($editor[0], 'WebScriptControlData', data);
					});
				} else {
					hideJSScriptEditorLoadingIndicator();
					if (typeof (callback) === 'function') callback();
				}
			}).fail(function () {
				hideJSScriptEditorLoadingIndicator();
				alert("Error loading data - QX Web service isn't available.");
			});
		} else {
			hideJSScriptEditorLoadingIndicator();
			if (typeof (callback) === 'function') callback();
		}
	}
}

function loadJSScriptEditorIncludes(urlList, token, onCompleated) {
	var externalLibsData = [];
	var urls = (urlList || '').split(',');
	loadJSScriptEditorIncludeImpl(urls, token, 0, externalLibsData, onCompleated);
}

function loadJSScriptEditorIncludeImpl(urls, token, index, externalLibsData, onCompleated) {
	if (urls && index < urls.length && urls[index]) {
		// only absolute URLs are supported
		if (urls[index].lastIndexOf("http", 0) != 0) {
			throw 'JScript Library include URL "' + urls[index] + '" is not supported.';
		}

		//require(['text!' + urls[index]], function (text) {
		$.ajax({
			type: 'GET',
			url: urls[index],
			headers: { 'X-Auth-Token': token },
			dataType: 'text',
			crossDomain: true,
			cache: true
		}).done(function (text) {
			externalLibsData.push(text);
			loadJSScriptEditorIncludeImpl(urls, token, ++index, externalLibsData, onCompleated);
		}).fail(function (e1, e2, e3) {
			hideJSScriptEditorLoadingIndicator();
			alert('Error loading Script Library, URL: ' + urls[index]
				+ '\nError: ' + ((e1 && e1.statusText) || e3 || e2 || 'Unknown Error'));
		});
	} else {
		if (typeof (onCompleated) === 'function') onCompleated(externalLibsData);
	}
}

function disposeJSScriptEditorById(id, fixModal) {
	var editorObj = _getJSScriptEditorById(id);
	disposeJSScriptEditor(editorObj, null, fixModal);
}

function disposeJSScriptEditor(editorObj, callBack, fixModal) {
	if (editorObj && editorObj.domNode) {
		cancelJSScriptEditorSessionTimer(editorObj);
		// fix by default - questions tab issues...
		if (fixModal || typeof (fixModal) === 'undefined') {
			// restore modal to initial state if needed
			var editorId = editorObj.domNode.id;
			var $modalHost = $('div.modal:has(#' + editorId + ')');
			if ($modalHost && $modalHost.length > 0 && $modalHost.data('absolute') !== false) {
				if ($modalHost.hasClass('absp-fullscreen')) {
					toggleAbsPFullscreen($modalHost);
				}
				var $fullscreenContent = $modalHost.find('.monaco-editor-fullscreen');
				if ($fullscreenContent && $fullscreenContent.length > 0) {
					toggleAbsPFullscreen($fullscreenContent, null, 'monaco-editor-fullscreen', 'monaco-editor-in-fullscreen');
				}
			}
		}

		$.data(editorObj.domNode, 'editorObj', null);
	}

	if (editorObj) {
		$(window).off('resize.responsiveEditor', editorObj.onWindowResize);

		if (editorObj.editor) {
			editorObj.editor.dispose();
			editorObj.editor = null;
		}

		if (editorObj.globalsIncludes) {
			for (var i = 0; i < editorObj.globalsIncludes.length; i++) {
				editorObj.globalsIncludes[i].dispose();
			}
			editorObj.globalsIncludes = null;
		}

		if (editorObj.globalsModel) {
			editorObj.globalsModel.dispose();
			editorObj.globalsModel = null;
		}

		if (editorObj.coreLibModel) {
			editorObj.coreLibModel.dispose();
			editorObj.coreLibModel = null;
		}
	}

	if (typeof (callBack) === 'function') {
		callBack();
	}
}

function cancelJSScriptEditorSessionTimer(editorObj) {
	// clear session timer
	if (editorObj && editorObj.domNode) {
		var keepAliveTimer = $.data(editorObj.domNode, "timer");
		if (keepAliveTimer) {
			keepAliveTimer.stop();
		}
		$.data(editorObj.domNode, 'timer', null);
	}
}

function initJSScriptEditorImpl($editor, code, externalLibs, readOnly, editMode, editorCreatedCallback) {
	'use strict';

	var self = (this && this.hasOwnProperty('editorObj')) ? this : {};
	self.editorObj = {
		domNode: $editor[0],
		rawValue: $editor.text(),
		editor: null,
		globalsModel: null
	};

	$editor.text('');

	if (typeof (Sys) != 'undefined') {
		var prmInstance = Sys.WebForms.PageRequestManager.getInstance();
		var handler = function (p1, p2, p3, p4) {
			prmInstance.remove_initializeRequest(handler);
			disposeJSScriptEditor(self.editorObj);
		};
		prmInstance.add_initializeRequest(handler);
	}

	(function () {
		require(['vs/editor/editor.main.nls', 'vs/editor/editor.main',
			'vs/nls!vs/editor/editor.main', 'vs/css!vs/editor/editor.main'], function () {
				Monaco.Editor.getOrCreateMode(editMode).then(function (mode) {
					if (mode._descriptor.id === "typescript") {
						// cleanup all editor project files
						var projectResolver = mode._getProjectResolver();
						projectResolver._needsProjectUpdate = true;
						if (projectResolver._projectChange) {
							projectResolver._projectChange.files = [];
						}

						// we aware of functions defined in a script library
						if (externalLibs) {
							self.editorObj.globalsIncludes = [];
							for (var i = 0; i < externalLibs.length; i++) {
								var elModel = Monaco.Editor.createModel(externalLibs[i], mode);
								//projectResolver.addExtraLib(elModel.getValue(), elModel.getAssociatedResource().path);
								projectResolver._projectChange.files.push(elModel.getAssociatedResource());
								self.editorObj.globalsIncludes.push(elModel);
							}
						}

						// overrides code
						if (code) {
							self.editorObj.globalsModel = Monaco.Editor.createModel(code, mode);
							//self.editorObj.globalsModel.emitModelPropertiesChangedEvent();
							//projectResolver.addExtraLib(self.editorObj.globalsModel.getValue(), self.editorObj.globalsModel.getAssociatedResource().path);
							projectResolver._projectChange.files.push(self.editorObj.globalsModel.getAssociatedResource());
						}
					}

					// create a new editor
					self.editorObj.editor = Monaco.Editor.create(self.editorObj.domNode, {
						value: self.editorObj.rawValue,
						mode: mode,
						readOnly: readOnly,
						fontIsMonospace: true,
						suggestOnTriggerCharacters: true,
						showTypeScriptWarnings: true
					});

					require(['vs/base/common/winjs.base'], function (winjs_base) {
						// "Peek Definition" (Alt+F12) fix
						self.editorObj.editor._editorService.resolveEditorModel = function (typedData, refresh) {
							var _this = this;
							if (typedData && typedData.resource) {
								var path = typedData.resource._path;
								if (path) {
									var globalModel;
									if (self.editorObj.globalsModel && self.editorObj.globalsModel.getAssociatedResource().path == path) {
										globalModel = self.editorObj.globalsModel;
									}

									if (!globalModel && self.editorObj.globalsIncludes) {
										for (var i = 0; i < self.editorObj.globalsIncludes.length; i++) {
											var jsModel = self.editorObj.globalsIncludes[i];
											if (jsModel.getAssociatedResource().path == path) {
												globalModel = jsModel;
												break;
											}
										}
									}

									if (globalModel) {
										return winjs_base.TPromise.as({ textEditorModel: globalModel });
									}
								}
							}

							var teModel = this.editor.withTypedEditor(function (editor) {
								return _this.findModel(editor, typedData);
							}, function (diffEditor) {
								return _this.findModel(diffEditor.getOriginalEditor(), typedData) || _this.findModel(diffEditor.getModifiedEditor(), typedData);
							});

							if (teModel) return winjs_base.TPromise.as({ textEditorModel: teModel });

							if (!self.editorObj.coreLibModel) {
								self.editorObj.coreLibModel = Monaco.Editor.createModel('// The target element defined in the Core Library.\n// Preview is not available.', mode);
							}

							return winjs_base.TPromise.as({ textEditorModel: self.editorObj.coreLibModel });
						};
					});

					self.editorObj.onWindowResize = function (event) {
						// keep fullscreen mode resize handling as is
						if (self.editorObj && self.editorObj.domNode
							&& $(self.editorObj.domNode).closest('.monaco-editor-fullscreen').length === 0) {
							var $editorNode = $(self.editorObj.domNode);
							var $holder = $editorNode.parent();
							// adjust holder size 4by3 by default for script dialogs only
							if ($editorNode.hasClass('monaco-script-editor')
								&& $editorNode.closest('.modal-dialog').length > 0) {
								$holder.height($holder.width() * 3 / 4);
							} else if ($holder.is('[style]')) {
								// restore default height
								$holder.height('475px');
							}
							resizeJSScriptEditor(self.editorObj);
						}
					};

					// make responsive
					$(window).on('resize.responsiveEditor', self.editorObj.onWindowResize);

					// uncomment for debug only
					//window._mse_instance = self.editorObj.editor;

					// force focus (without scroll) on editor
					if (!readOnly) {
						var $editElement = $('textarea.inputarea');
						if ($editElement && $editElement.length > 0 && typeof ($editElement[0].focus) === 'function') {
							var scrollElement = document.documentElement || document.body;
							if (scrollElement) {
								var scrollTop = scrollElement.scrollTop;
								var scrollLeft = scrollElement.scrollLeft;

								$editElement[0].focus();

								if (scrollTop > 0 || scrollLeft > 0) {
									scrollElement.scrollTop = scrollTop;
									scrollElement.scrollLeft = scrollLeft;
								}
							}
						}
					}

					// cleanup editor obj
					self.editorObj.rawValue = null;

					// save editor object data for future use
					$.data(self.editorObj.domNode, 'editorObj', self.editorObj);

					// show the editor if hidden
					$(self.editorObj.domNode).closest('.script-editor.hidden-editor, .html-editor.hidden-editor').removeClass('hidden-editor');

					// resize the editor
					self.editorObj.onWindowResize();

					if (editorCreatedCallback) {
						editorCreatedCallback(self.editorObj);
					}
					$editor.removeAttr('data-initializing');
					self.initialized = true;
					$editor.attr('data-initialized', 'true');
				});
			});
	})();
}

// submit from "Update Pannel"
function submitJSScriptEditor(id, resultId, useWebApi) {
	var $editor = $('#' + id);
	var $result = $('#' + resultId);

	// editor DOM node may be removed from parent form
	if ($editor && $editor.length) {
		if (!useWebApi) {
			var editorObj = $.data($editor[0], 'editorObj');
			if (editorObj) {
				// store result in the hidden field
				$result.val(editorObj.editor.getModel().getValue());
			}
		}

		cancelJSScriptEditorSessionTimer(editorObj);
	}

	return true;
}

function confirmJSScriptEdit(postbackTargetId, id, resultId, param, useWebApi) {
	if (param) {
		param = 'Save|' + param;
	} else {
		param = 'Save';
	}

	if (!useWebApi) {
		submitJSScriptEditor(id, resultId, useWebApi);

		// do the same thing as for silverlight
		setTimeout(function () {
			__doPostBack(postbackTargetId, param);
		}, 0);
	} else {
		var $editor = $('#' + id);
		var $result = $('#' + resultId);

		var webApiUrl = $.data($editor[0], 'WebApiUrl');
		var data = $.data($editor[0], 'WebScriptControlData');
		var editorObj = $.data($editor[0], 'editorObj');

		if (webApiUrl && data && editorObj && editorObj.editor) {
			data.script = editorObj.editor.getModel().getValue();

			$.ajax({
				type: 'POST',
				url: webApiUrl + '?token=' + $result.val(),
				contentType: 'application/json; charset=UTF-8',
				data: JSON.stringify(data),
				dataType: 'json', // set return type - no auto-detect
				processData: false, // already a json string
				crossDomain: true,
				//xhrFields: {
				//    withCredentials: true
				//},
			}).done(function (data) {
				// do the same thing as for silverlight
				__doPostBack(postbackTargetId, param);
			}).fail(function () {
				alert("Error saving data - QX Web service isn't available.");
			});
		} else {
			alert('There was an error retrieving data from the Monaco Editor control.');
		}
	}

	return false;
}

// -- codegen region
function GenerateTSCodeForVariablesAndOverrides(overrides, variables) {
	var code = "\n";

	var overridesList = overrides ? overrides.split("|") : [];
	var overridesData = [];
	var overridesTypes = [];

	overridesList.forEach(function (item) {
		var itemParts = item.split("-");
		var typeEndIndex = itemParts[0].lastIndexOf(".");
		var type = itemParts[0].substring(0, typeEndIndex);
		var prop = itemParts[0].substring(typeEndIndex + 1, itemParts[0].length);
		var newPropType = itemParts[1];
		if (overridesTypes.lastIndexOf(type) === -1) {
			overridesTypes.push(type);
		}
		overridesData.push({ type: type, prop: prop, newPropType: newPropType });
	});

	overridesTypes.forEach(function (type) {
		var nsEndIndex = type.lastIndexOf(".");
		var nsName = type.substring(0, nsEndIndex);
		var typeName = type.substring(nsEndIndex + 1, type.length);

		code += "namespace " + nsName + " {\n";
		code += "    /** [System] Editor Global overrided type {" + type + "}. */\n";
		code += "    export class " + typeName + "_ extends " + type + " {\n";

		// props
		overridesData.forEach(function (propInfo) {
			if (propInfo.type == type) {
				var newPropType = propInfo.newPropType;
				if (overridesTypes.lastIndexOf(newPropType) !== -1) {
					newPropType += '_';
				}

				code += "        /** [System] Editor Global overrided property. */\n";
				code += "        " + propInfo.prop + ": " + newPropType + ";\n";
			}
		});

		code += "    }\n";
		code += "}\n\n";
	});

	var globalVarsList = variables ? variables.split("|") : [];
	globalVarsList.forEach(function (item) {
		var varParts = item.split("-");
		var varName = varParts[0];
		var varType = varParts[1];

		code += "/** [System] Editor Global variable of type {" + varType + "}. */\n";

		if (overridesTypes.lastIndexOf(varType) !== -1) {
			varType += '_';
		}

		code += "var " + varName + ": " + varType + ";\n";
	});

	code += "\n";

	return code;
}

// -- end of codegen region

function TypeScriptSnippetService() {
	this.codeSnippets = [{
		codeSnippet: "if ({{condition}})\n\{\n    {{}}\n\}",
		documentationLabel: "If Statement.",
		label: "if",
		displayName: "if",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "else\n\{\n    {{}}\n\}",
		documentationLabel: "Else Statement.",
		label: "else",
		displayName: "else",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "if ({{condition}})\n\{\n    {{_}}\n\}\nelse\n\{\n    {{}}\n\}",
		documentationLabel: "If-Else Statement.",
		label: "ifelse",
		displayName: "if...else",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "for (var {{i}} = 0; {{i}} < {{array}}.length; {{i}}++)\n\{\n    var {{element}} = {{array}}[{{i}}];\n    {{}}\n\}",
		documentationLabel: "For Loop.",
		label: "for",
		displayName: "for",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "for (var {{item}} in {{list}})\n\{\n    {{}}\n\}",
		documentationLabel: "For-In Loop.",
		label: "forin",
		displayName: "foreach",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "for (var {{i}} = {{array}}.length - 1; {{i}} >= 0; {{i}}--)\n\{\n    var {{element}} = {{array}}[{{i}}];\n    {{}}\n\}",
		documentationLabel: "Reverse For Loop.",
		label: "forr",
		displayName: "for reverse",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "while ({{condition}})\n\{\n    {{}}\n\}",
		documentationLabel: "While Statement.",
		label: "while",
		displayName: "while",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "do\n\{\n    {{}}\n\}\nwhile ({{condition}});",
		documentationLabel: "Do-While Statement.",
		label: "dowhile",
		displayName: "do",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "switch ({{key}})\n\{\n    case {{value}}:\n        {{}}\n        break;\n    default:\n        break;\n\}",
		documentationLabel: "Switch Statement.",
		label: "switch",
		displayName: "switch",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "function {{name}}({{params}})\n\{\n    {{}}\n\}",
		documentationLabel: "Function Statement.",
		label: "function",
		displayName: "function",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "with ({{expression}})\n\{\n    {{}}\n\}",
		documentationLabel: "With Statement. \nUse of the with statement is not recommended, as it may be the source of confusing bugs and compatibility issues.",
		label: "with",
		displayName: "with",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "return {{_}};{{}}",
		documentationLabel: "Return statement.",
		label: "ret",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "return false;{{}}",
		documentationLabel: "Return false.",
		label: "ret0",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "return true;{{}}",
		documentationLabel: "Return true.",
		label: "ret1",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: 'throw "{{_}}";\n{{}}',
		documentationLabel: "Throw Exception.",
		label: "throw",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "{{array}}.forEach(function({{element}})\n\{\n    {{}}\n\});",
		documentationLabel: "For-Each Loop using 'Array.forEach'.",
		label: "forEach",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "var {{name}} = new {{type}}({{arguments}});{{}}",
		documentationLabel: "New Statement.",
		label: "new",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "try\n\{\n    {{}}\n\}\ncatch ({{error}})\n\{\n    \n\}",
		documentationLabel: "Try-Catch Statement.",
		label: "trycatch",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "setTimeout(function()\n\{\n    {{}}\n\}, {{timeout}});",
		documentationLabel: "Set Timeout Function.",
		label: "settimeout",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "if ({{Event.Value}})\n\{\n    {{Event.Value}} = {{Event.Value}}.PadLeft(9, '0');\n\}",
		documentationLabel: "Fix SSN Code Snippet.",
		label: "fixssn",
		displayName: "Fix SSN",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "var {{key}} = Event.Record[\"Employee SSN\"] + Event.ColumnName;\nif (!Event.Globals[{{key}}])\n\{\n    Event.Globals[{{key}}] = 0;\n\}\n{{Event.Value}} = (++Event.Globals[{{key}}]).ToString();",
		documentationLabel: "ID Generation Code Snippet.",
		label: "genid",
		displayName: "Generate ID",
		noAutoAccept: true,
		type: "snippet"
	}, {
		codeSnippet: "var {{key}} = {{Event.ColumnName}};\nif (!Event.Globals[{{key}}])\n\{\n    Event.Globals[{{key}}] = 0;\n\}\n{{Event.Value}} = (++Event.Globals[{{key}}]).ToString();",
		documentationLabel: "Sequance Generation Code Snippet.",
		label: "sequance",
		displayName: "Sequance",
		noAutoAccept: true,
		type: "snippet"
	}]
}

TypeScriptSnippetService.prototype.suggest = function (all, triggerCharacter, groups) {
	var supportGroup = groups[0][0];
	if (!supportGroup || !supportGroup.mode
		|| supportGroup.mode.getId() !== 'typescript') {
		return;
	}

	var allSuggests = all[0][0];
	if (!allSuggests || triggerCharacter) {
		return;
	}

	var currentWord = all.currentWord;
	var suggests = this.codeSnippets;
	if (currentWord && currentWord.length > 0) {
		suggests = [];
		for (var i = 0; i < this.codeSnippets.length; i++) {
			var snippet = this.codeSnippets[i];
			if (snippet.label.lastIndexOf(currentWord) !== -1) {
				suggests.push(snippet);
			}
		}
	}

	if (suggests.length > 0) {
		Array.prototype.push.apply(allSuggests.suggestions, suggests);
	}
}

window.TSSnippetService = new TypeScriptSnippetService();
